module.exports = __webpack_public_path__ + "img/soft_13.25e9b309.png";